import {css, StyleSheet} from 'aphrodite';
import gql from 'graphql-tag';
import React from 'react';

import {ToggleHighlightParams} from 'chemistry/ChemSearchUtils';
import {MoleculeImagePopoverQuery} from 'chemistry/molecules/__generated/MoleculeImagePopoverQuery';
import {ErrorFragment, isError} from 'graphql-client/Error';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';

type MoleculeImage = MoleculeImagePopoverQuery['moleculeImage'];

// TODO BNCH-40192: Have this file to run its own query once popover positioning issue is fixed.
// Due to some placement bugs with Benchling's current popover, this query needs to be run by the parent
// component so that the parent can render null as the popover content until the query is finished.
export const MOLECULE_IMAGE_POPOVER_QUERY = gql`
  query MoleculeImagePopoverQuery($mol: StrictString!) @skipAudit @engComponent(name: CHEMISTRY) {
    moleculeImage(mol: $mol) {
      ... on SVGNode {
        base64Svg
      }
      ...Error
    }
  }
  ${ErrorFragment.fragment}
`;

interface MoleculeImagePopoverProps {
  toggleHighlightParams?: ToggleHighlightParams;
  moleculeImage: MoleculeImage;
}

export function MoleculeImagePopover(props: MoleculeImagePopoverProps): JSX.Element | null {
  const moleculeImageContent = isError(props.moleculeImage) ? (
    props.moleculeImage.message
  ) : (
    <img
      className={css(styles.substructureImg)}
      src={`data:image/svg+xml;base64,${props.moleculeImage.base64Svg}`}
    />
  );
  const toggleHighlightOption = props.toggleHighlightParams?.showToggleHighlightOption ? (
    <CheckboxInput
      id="toggleHighlightOption"
      checked={props.toggleHighlightParams.shouldHighlightSubstructure}
      onChange={(e) => {
        props.toggleHighlightParams!.setShouldHighlightSubstructure(e.target.checked);
      }}
      label="Highlight substructure in search results."
    />
  ) : null;
  return (
    <div className={css(styles.popoverContentWrapper)}>
      {toggleHighlightOption}
      {moleculeImageContent}
    </div>
  );
}

const styles = StyleSheet.create({
  popoverContentWrapper: {
    textAlign: 'center',
  },
  substructureImg: {
    width: '200px',
    height: '200px',
  },
});
